import styled from 'styled-components';

export const CartLineItemColumnTotalWrapper = styled.div`
  width: 15%;
  display: flex;
  align-items: center;
`;
